var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SideNavBar'),_c('transition',{attrs:{"name":"fade-transform","mode":"out-in"}},[_c('router-view',{class:_vm.menuStatus ? 'extra-width' : ''})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }